import { InfoBanner } from "@screencloud/screencloud-ui-components";
import { type InjectedIntlProps, injectIntl } from "react-intl";
import styled from "styled-components";

/**
 * InfoBanner's `.core` is `height: 100%` with `justify-content: flex-start`, so
 * a single-line description sits at the TOP of the banner rather than centered.
 * And its `.icon` is a block whose baseline line-box leaves the glyph sitting
 * high. Center everything vertically: center the row, center the content inside
 * the full-height core, and flex-center the icon glyph (dropping its top nudge).
 * `&&` doubles specificity so these beat InfoBanner's own rules regardless of
 * stylesheet order.
 */
const CenteredInfoBanner = styled(InfoBanner)`
  && {
    align-items: center;
  }

  && > div.icon {
    display: flex;
    align-items: center;
  }

  && > div.icon i {
    margin-top: 0;
  }

  && > div.core {
    justify-content: center;
  }
`;

/**
 * Informational banner shown when the Invoice payment method is selected.
 * Mirrors the billinglatest invoice notice — no fields to fill; the actual
 * `createPaymentSourceInvoice` call happens at Checkout.
 */
function InvoiceNoticeBase({ intl }: InjectedIntlProps) {
  return (
    <CenteredInfoBanner
      color="warning"
      icon="info"
      data-testid="invoice-notice"
      description={intl.formatMessage({
        id: "pixi_wizard.payment_shipping.invoice_notice",
        defaultMessage:
          "Invoice billing is available as an annual option only, with a minimum license of 5 screens.",
      })}
    />
  );
}

export const InvoiceNotice = injectIntl(InvoiceNoticeBase);
